import { render, staticRenderFns } from "./setAPI.vue?vue&type=template&id=65527f7c&scoped=true&"
import script from "./setAPI.vue?vue&type=script&lang=js&"
export * from "./setAPI.vue?vue&type=script&lang=js&"
import style0 from "./setAPI.vue?vue&type=style&index=0&id=65527f7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65527f7c",
  null
  
)

export default component.exports